export enum ERROR_CODES {
  GENERIC = 'GENERIC_ERROR',
  ERROR_RESPONSE = 'ERROR RESPONSE',
  EKYC_REF_ERROR_CODE = 'f8a2d7b1e9c34560',
  SYSTEM_ERROR = 'SYSTEM_ERROR'
}

export enum ERROR_MESSAGE {
  BACK_ORDER_RESERVE_FAILED = 'reserve rejected in virtual inventory'
}

export type GatsbyImage = {
  image: {
    src: string;
  };
};

export type ImageItem = {
  src: string;
};

interface ErrorMessage {
  __typename: string;
  errorCode: string;
  bccErrorCode: string;
  title: string;
  description: string;
  enableCTA: boolean;
  ctaActionType: string;
  ctaType: string;
  ctaText: string;
  ctaURL: string;
  footerLinks: FooterLink[];
}

interface FooterLink {
  label: string;
  link: string;
  type: string;
}

// global any to prevent warning all over the use
type APP_TYPE_ANY = any;

interface KeyValue {
  [key: string]: APP_TYPE_ANY;
}

export interface AppState extends KeyValue {
  loading?: boolean;
  isLoading?: boolean;
  isError?: boolean;
  errorCode?: string;
  error?: boolean;
  errorMessage?: string;
  errorTitle?: string;
  skeletonLoading?: boolean;
  allowReload?: boolean;
  _gaErrorMeta?: string;
}

export type Translate = (text: string) => string;
export { FooterLink, ErrorMessage, ERROR_CODES, KeyValue, APP_TYPE_ANY };
export type Action = {
  type: string;
  value?: KeyValue;
  payload?: KeyValue;
  data?: KeyValue;
};

export type AemVariableConfig = {
  name: string;
  value: string;
};

export const EmptyFn = (): void => {
  // doesn't do anything
};

export type ArgumentObjType = Record<string, APP_TYPE_ANY>;

export type AtLeastOneArgument<T, K extends keyof T = keyof T> = Partial<T> &
  {
    [P in K]: Required<Pick<T, P>> & Partial<Record<Exclude<K, P>, never>>;
  }[K];

export interface SpecialPromo {
  promoCode: string;
  planIds: string[];
  boIds: string[];
  pretickBoIds?: string[];
  showPhysicalSim?: boolean;
}

export enum TransactionType {
  NEW_SIGN_UP = 'newSignup',
  RECON = 'recontract',
  PORT_IN = 'portIn'
}

export interface EshopMtposAvailability {
  itemCode: string;
  availableInWarehouse: boolean;
  availableInStore: boolean;
  available: boolean;
  isAvailable: boolean;
  backorder?: boolean;
}

export interface Availability {
  allocationID?: number;
  status: string;
  itemCode: string;
  availableQty: number;
}

export type PreTickItem = {
  boIds?: string[] | null;
  [key: string]: any;
};

export interface GroupAddon {
  id: string;
  usualMonthlyPrice: string;
  actualMonthlyPrice: string;
  description: string;
  promoText: string | null;
  contractTerm: string;
  oneTimePayment?: string;
}

export interface ServiceAddonType {
  categoryId: string;
  category: string;
  id: string;
  title: string;
  usualMonthlyPrice: string | null;
  actualMonthlyPrice: string;
  image: string;
  promoText?: string | null;
  description: string | null;
  contractDescription?: string;
  contractTerm: string;
  groupAddons?: GroupAddon[] | null;
  oneTimePayment?: string;
  footerLiner?: string;
  price?: string; // Formatted price string for display (e.g., "$3.46/mth")
  addonBoid?: string;
  loading?: string;
}
